import { useActiveWorkspaceDetails } from "./useActiveWorkspaceDetails";
import { useCurrentUserIsWorkspaceOrganizationMember } from "./useCurrentUserIsWorkspaceOrganizationMember";

/**
 * True for firm members and for standalone business owners (workspace with
 * no organization). False for clients of a firm-managed workspace, who do not
 * see the agent identity or the "via Agent" / "via MCP" attribution.
 */
export function useIsFirmMemberOrStandaloneUser(): boolean {
    const workspaceDetails = useActiveWorkspaceDetails();
    const { isOrganizationMember } =
        useCurrentUserIsWorkspaceOrganizationMember();
    const isFirmManaged =
        workspaceDetails !== undefined &&
        workspaceDetails.organizationAssignments.length > 0;
    return !isFirmManaged || isOrganizationMember;
}
